import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col as Column,
  Form,
  FormGroup,
  Label,
  Input,
  Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle, CardHeader,
  Button,
  Alert
} from 'reactstrap';

import propTypes from 'prop-types';
import {convertToRupiah} from '../../utils'
import {
  ADMINISTRATOR,
  APPROVED,
  SUSPEND,
  REJECTED,
  UNDER_REVIEW,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  CANCELLED,
  DRAFT,
  MORE_INFO,
  SEMPURNA,
  CACAT,
  NO_BOX,
  BARU,
  BEKAS,
  LISTING,
} from '../../utils'
import ReactLoading from 'react-loading';
import { getCacheImage } from '../../config'

const valueReg3 = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
const valueReg4 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
/* jika tampilan berubah pada saat development untuk check responsive refresh dulu */
const ModalEditSellPrice = (props) => {
  let isMobile = false; //initiate as false
  // device detection
  if(valueReg3.test(navigator.userAgent) || valueReg4.test(navigator.userAgent.substr(0,4))) {
      isMobile = true;
  }
  const imageContent = props.imagesVariant.reduce((acc, curV, curI)=>{
    let separated = isMobile ? 3 : 2
    if(!(curI % separated)){
      acc.push([curV])
      return acc
    } else {
      let tempPop = acc.pop()
      tempPop.push(curV)
      acc.push(tempPop)
      return acc
    }
  },[])

  return(
    <Modal isOpen={props.isOpen} toggle={props.onToggle} className="kick-modal" contentClassName="sell-price">
      <Container>
        <ModalHeader id="header-sell-price">
          {props.onData.product_variant.display_name}
        </ModalHeader>
        <ModalBody>
          <Card className="mb-3">
            <CardHeader><i className="fa fa-picture-o"></i> Gambar Penjualan</CardHeader>
            <CardBody className="modal-edit-price">
              <Row>
                {
                  imageContent.length ?
                  imageContent.map((data, index)=>{
                    return(
                    <Column key={index} xs={12} sm={12} md={6} className={!(index%2)?'left':'right'}>
                      <CardBody className="modal-edit-price body-image">
                        <Row>
                          {
                            data.map((images, index)=>{
                              return(
                                <Column key={index} xs={4} sm={6} md={6} className="col-image">
                                  <CardBody className="box-image">
                                    <CardImg src={getCacheImage(images.signed_url || images.URL)} alt={images.URL}/>
                                  </CardBody>
                                </Column>
                              )
                            })
                          }
                        </Row>
                      </CardBody>
                    </Column>
                    )
                  })
                  :
                  <Column xs={12} sm={12} md={12}>
                    <Alert color="danger" style={{"textAlign":"center"}} className="mb-0"><strong>Ooops.. </strong> No Images Found!</Alert>
                  </Column>
                }
              </Row>
            </CardBody>
          </Card>
          <Card className="mb-3">
            <CardHeader><i className="fa fa-picture-o"></i> Info Penjualan</CardHeader>
            <CardBody className="modal-edit-price">
              <Row>
                <Column xs={12} sm={12} md={6}>
                  <FormGroup>
                    <Label xs={12} md={12} className="form-control-label" for="forSellStatus">Status</Label>
                    <Input
                      id="forSellStatus"
                      name="status-sell"
                      type="text"
                      value={infoString(props.onData.status)}
                      className="text-center placeholder"
                      placeholder="Status Penjualan Anda"
                      disabled
                    />
                  </FormGroup>
                </Column>
                <Column xs={12} sm={12} md={6}>
                  <FormGroup>
                      <Label xs={12} md={12} className="form-control-label" for="forSellCondition">Kondisi Sneaker</Label>
                      <Input
                        id="forSellCondition"
                        name="condition-sell"
                        type="text"
                        value={infoString(props.onData.sneakers_condition)}
                        className="text-center placeholder"
                        placeholder="Kondisi Sneaker Anda"
                        disabled
                      />
                    </FormGroup>
                </Column>
              </Row>
              <Row>
                <Column xs={12} sm={12} md={6}>
                  <FormGroup>
                    <Label xs={12} md={12} className="form-control-label" for="forSellBox">Kondisi Box</Label>
                    <Input
                      id="forSellBox"
                      name="box-sell"
                      type="text"
                      value={infoString(props.onData.box_condition)}
                      className="text-center placeholder"
                      placeholder="Kondisi Box Anda"
                      disabled
                    />
                  </FormGroup>
                </Column>
                <Column xs={12} sm={12} md={6}>
                  <FormGroup>
                      <Label xs={12} md={12} className="form-control-label" for="forSellPrice">Harga</Label>
                      <Input
                        id="forSellPrice"
                        name="price-sell"
                        type="text"
                        value={convertToRupiah(parseInt(props.onData.asking_price))}
                        onChange={props.onChangePrice}
                        className="text-right placeholder price"
                        placeholder="Masukkan Harga, Ex: 9000000"
                      />
                    </FormGroup>
                </Column>
              </Row>
              {
                props.onData.consignment_id ?
                (
                  <Row>
                    <Column xs={12} sm={12} md={{ size: 8, offset: 2 }}>
                      <FormGroup>
                        <Label xs={12} md={12} className="text-center" for="forSellConsignmentID">Consignment ID</Label>
                        <Input
                          id="forSellConsignmentID"
                          name="consignment-id"
                          type="text"
                          value={props.onData.consignment_id}
                          className="text-center placeholder"
                          disabled
                        />
                        </FormGroup>
                    </Column>
                  </Row>
                )
                :
                null
              }
            </CardBody>
          </Card>
          <Alert color="danger" style={{"textAlign":"center"}} isOpen={props.isError} className="mb-0 error-submit-price"><strong>Oops.. Failed!! </strong>{props.isErrorMsg}</Alert>
        </ModalBody>
        <ModalFooter>
          <Button color="success" disabled={props.isProcessSubmit} className="btn-green" onClick={()=>props.onSubmit('submit')} style={{display: 'flex', flex: 1, 'justifyContent': 'center'}}>
            {props.isProcessSubmit ? <ReactLoading type={'bars'} height={20} width={20} /> : 'Submit'}
          </Button>
        </ModalFooter>
      </Container>
    </Modal>
  )
}

const infoString = (data) => {
  switch (data) {
    case SEMPURNA[0]: return SEMPURNA[1]
    case CACAT[0]: return CACAT[1]
    case NO_BOX[0]: return NO_BOX[1]
    case BARU[0]: return BARU[1]
    case BEKAS[0]: return BEKAS[1]
    case APPROVED: return LISTING[0]
    case SUSPEND: return LISTING[1]
    case DRAFT[0]: return DRAFT[1]
    case MORE_INFO[0]: return MORE_INFO[1]
    case CANCELLED[0]: return CANCELLED[1]
    case WAIT_CONFIRM[0]: return WAIT_CONFIRM[1]
    case WAIT_CONSIGN[0]: return WAIT_CONSIGN[1]
    case UNDER_REVIEW[0]: return UNDER_REVIEW[1]
    case REJECTED[0]: return REJECTED[1]
    default: return ADMINISTRATOR
  }
}

ModalEditSellPrice.propTypes={
  imagesVariant: propTypes.array,
  onData: propTypes.object
}

ModalEditSellPrice.defaultProps={
  imagesVariant: Array.from(Array(7).keys()),
}

export default ModalEditSellPrice
